import { TagSize } from './tag.types';

export const paddingRightBySize: Record<TagSize, number> = {
  sm: 0,
  md: 0.5,
  lg: 1,
};
